import { createApp } from "vue";
import App from "./App.vue";
import "@/utils/rem";
import "vant/lib/index.css";
import { Button, Sticky, Swipe, SwipeItem, Dialog } from "vant";
// 引入路由
import router from "./router";
import "./assets/baseCss.css";
let app = createApp(App);
app.use(router);
app.use(Button);
app.use(Sticky);
app.use(Swipe);
app.use(SwipeItem);
app.use(Dialog);
app.mount("#app");
